import * as firebase from 'firebase/app';
import * as firebaseAuth from 'firebase/auth';
import { FIREBASE_CONFIG } from '../config';

export class FirebaseProvider {
  firebase = firebase;
  auth;
  firebaseAuth = firebaseAuth;
  constructor(config: Record<string, string | undefined>) {
    if (!firebase.getApps().length) {
      const app = firebase.initializeApp(config);
      this.auth = firebaseAuth.getAuth(app);
    }
  }

  getFirebaseCurrentUser = (): firebaseAuth.User | null => {
    return this.auth.currentUser;
  };
}

export const firebaseProvider = new FirebaseProvider(FIREBASE_CONFIG);
